import { textBoxRequiredControl } from '../../../../../constants/form-control/core/common/textbox/textbox-required';
import { FormControlUtil } from '../../../../../core/utils/form-control';

export const ScanTaskGroupFormConstant = {

  comment: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'comment',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Comment' }),
  }),
};
